import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React from "react";
import InputLabel from "@mui/material/InputLabel";
import strings from "../../config/localization";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

/**
 * Component that displays a single personnel type
 */

export default function Header(props) {
  console.log("Header, props:", props);

  const [metaData, setMetaData] = React.useState(props.metaData);

  React.useEffect(() => {
    setMetaData(props.metaData);
  }, [props]);

  return (
    <Stack direction="row">
      {metaData.map((field, index) => {
        console.log("Header, index: ", index);
        console.log("Header, field: ", field);
        return (
          <Typography
            key={index}
            variant="subtitle2"
            style={{ width: field.width }}
          >
            {field.label}
          </Typography>
        );
      })}
    </Stack>
  );
}
